<template>
  <div>

    <div class="main-view-container" v-if="!nonDesktopMode">
      <!--<AlertBart :alert-case="alertCase"></AlertBart>-->
      <v-row no-gutters style="justify-content: space-between;" class="desktop-header-row">
        <v-col>
          <v-breadcrumbs>
            <v-breadcrumbs-item class="breadcrumb-item" @click="selectPopularAsSport">
              {{ $t('breadcrumbs.home') }}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item class="breadcrumb-item" v-if="selectedSportInfo === 'none'">
              <v-icon color="inherit">krypt-arrow-pointer-right</v-icon>

              {{ $t('sports.popular') }}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item v-if="selectedSportInfo !== 'none'" class="breadcrumb-item"
                                @click="resetFiltersOfSport(selectedSportInfo.id)">
              <v-breadcrumbs-divider>
                <v-icon>krypt-arrow-pointer-right</v-icon>
              </v-breadcrumbs-divider>
              {{$t(`sports.${selectedSportInfo.name}`)}}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item v-if="selectedCategoryInfo !== 'none' && selectedCompetitionInfo==='none'"
                                class="breadcrumb-item">
              <v-breadcrumbs-divider>
                <v-icon>krypt-arrow-pointer-right</v-icon>
              </v-breadcrumbs-divider>
              {{ selectedCategoryInfo.name}}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              v-if="( selectedCategoryInfo!=='none' ) && selectedCompetitionInfo !== 'none'"
              class="breadcrumb-item" @click="selectCategory(selectedCategoryInfo)">
              <v-breadcrumbs-divider>
                <v-icon>krypt-arrow-pointer-right</v-icon>
              </v-breadcrumbs-divider>
              {{ selectedCategoryInfo.name}}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              v-if="selectedCompetition !== 'none' && selectedEvent ==='none'"
              class="breadcrumb-item">
              <v-breadcrumbs-divider>
                <v-icon>krypt-arrow-pointer-right</v-icon>
              </v-breadcrumbs-divider>
              {{selectedCompetitionInfo.name}}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              v-if="selectedCompetitionInfo !== 'none' && selectedEvent !=='none'"
              class="breadcrumb-item" @click="selectTournament(selectedCompetitionInfo)">
              <v-breadcrumbs-divider>
                <v-icon>krypt-arrow-pointer-right</v-icon>
              </v-breadcrumbs-divider>
              {{selectedCompetitionInfo.name}}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              v-if="selectedEvent !== 'none' && selectedEvent.eventType !=='Virtual'"
              class="breadcrumb-item">
              <v-breadcrumbs-divider>
                <v-icon>krypt-arrow-pointer-right</v-icon>
              </v-breadcrumbs-divider>
              {{selectedEvent.homeTeam}} &ndash; {{selectedEvent.awayTeam}}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              v-if="selectedEvent !== 'none' && selectedEvent.eventType ==='Virtual'"
              class="breadcrumb-item">
              <v-breadcrumbs-divider>
                <v-icon>krypt-arrow-pointer-right</v-icon>
              </v-breadcrumbs-divider>
              {{selectedEvent.name}}
            </v-breadcrumbs-item>
          </v-breadcrumbs>
          <div v-if="selectedEvent ==='none'">
            <v-subheader class="main-section-header" v-if="selectedSport ==='none'">
              <!--              <v-img :src="sportsToIconsMapping[0]" class="main-section-header-icon"-->
              <!--                     height="32"-->
              <!--                     max-width="32"-->
              <!--              ></v-img>-->

              {{ $t('sports.popular')}}
            </v-subheader>
            <v-subheader class="main-section-header"
                         v-if="selectedSport !== 'none' && selectedCategory === 'none' && selectedCompetition === 'none' ">
              <img :src="sportsToIconsMapping[selectedSportData.sportIdentifier]"
                   class="main-section-header-icon"
                   height="32"
                   max-width="32"
              ></img>

              {{$t(`sports.${selectedSportData.sportIdentifier}`)}}

            </v-subheader>


            <v-subheader class="main-section-header"
                         v-if="selectedSport !=='none' && selectedCategory !== 'none' && selectedCompetition === 'none'">
              <img :src="sportsToIconsMapping[selectedSportData.sportIdentifier]"
                   class="main-section-header-icon"
                   height="32"
                   max-width="32"
              ></img>

              {{selectedCategory.name}}

            </v-subheader>
            <v-subheader class="main-section-header"
                         v-if="selectedSport !=='none' && selectedCompetition !== 'none' && selectedCategory === 'none'  ">
              <img :src="sportsToIconsMapping[selectedSportData.sportIdentifier]"
                   class="main-section-header-icon"
                   height="32"
                   max-width="32"
              ></img>

              {{selectedCompetition.name}}

            </v-subheader>
          </div>
        </v-col>
        <div class="time-filter-desktop" v-show="selectedEvent ==='none'">
          <TimeFrameComponent>

          </TimeFrameComponent>
        </div>
      </v-row>
      <EventsList v-show="initialStateReady && selectedEvent ==='none'"></EventsList>
      <EventView v-show="initialStateReady && selectedEvent !=='none'"></EventView>
      <EmptyEventsList v-show="!initialStateReady "></EmptyEventsList>

    </div>
    <div class="main-view-container-mobile" v-if="nonDesktopMode">
      <v-row class="main-section-header-mobile-row align-center" v-if="selectedEvent === 'none'">
        <div class="main-section-header-mobile"
             v-if="selectedSport !=='none' && selectedCategory === 'none' && selectedCompetition === 'none'">

          {{$t(`sports.${selectedSportData.sportIdentifier}`)}}

        </div>
        <div class="main-section-header-mobile" v-show="selectedSport !=='none' &&
          selectedCompetition !== 'none'">
          <!--            <img id="back-to-sports" @click="resetFiltersOfSport " class="empty-page-img" src="data:image/svg+xml;charset=UTF-8,%3csvg width='32' height='32' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M19.0383 11.0179C18.9729 11.0086 18.9066 11.0043 18.8403 11.0051H7.55262L7.79875 10.9049C8.03934 10.8054 8.25821 10.6698 8.44556 10.5045L11.6109 7.73629C12.0278 7.38826 12.0978 6.8284 11.7769 6.40976C11.4034 5.96366 10.6871 5.8668 10.1769 6.19345C10.1357 6.21986 10.0965 6.24864 10.0597 6.27961L4.33576 11.2854C3.88843 11.6761 3.88803 12.31 4.33486 12.7012C4.33515 12.7015 4.33547 12.7018 4.33576 12.702L10.0597 17.7078C10.5074 18.0982 11.2322 18.0973 11.6787 17.7058C11.7138 17.675 11.7466 17.6422 11.7769 17.6076C12.0978 17.189 12.0278 16.6291 11.6109 16.2811L8.45128 13.5079C8.28332 13.3609 8.09021 13.2376 7.87889 13.1425L7.53545 13.0074H18.7773C19.3621 13.0263 19.8752 12.6691 19.9851 12.1664C20.0863 11.6206 19.6624 11.1064 19.0383 11.0179Z' fill='%23a0a3a5'/%3e%3c/svg%3e ">-->

          <v-icon :src="BackIcon400" id="back-to-sports" @click="resetFiltersOfSport " :width="32"
                  :height="32">krypt-arrow-left
          </v-icon>
          {{selectedCompetition.name}}

        </div>
        <div class="main-section-header-mobile" v-show="selectedSport !=='none' &&
          selectedCategory !== 'none' &&  selectedCompetition === 'none'">
          <!--            <img id="back-to-sports" @click="resetFiltersOfSport " class="empty-page-img" src="data:image/svg+xml;charset=UTF-8,%3csvg width='32' height='32' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M19.0383 11.0179C18.9729 11.0086 18.9066 11.0043 18.8403 11.0051H7.55262L7.79875 10.9049C8.03934 10.8054 8.25821 10.6698 8.44556 10.5045L11.6109 7.73629C12.0278 7.38826 12.0978 6.8284 11.7769 6.40976C11.4034 5.96366 10.6871 5.8668 10.1769 6.19345C10.1357 6.21986 10.0965 6.24864 10.0597 6.27961L4.33576 11.2854C3.88843 11.6761 3.88803 12.31 4.33486 12.7012C4.33515 12.7015 4.33547 12.7018 4.33576 12.702L10.0597 17.7078C10.5074 18.0982 11.2322 18.0973 11.6787 17.7058C11.7138 17.675 11.7466 17.6422 11.7769 17.6076C12.0978 17.189 12.0278 16.6291 11.6109 16.2811L8.45128 13.5079C8.28332 13.3609 8.09021 13.2376 7.87889 13.1425L7.53545 13.0074H18.7773C19.3621 13.0263 19.8752 12.6691 19.9851 12.1664C20.0863 11.6206 19.6624 11.1064 19.0383 11.0179Z' fill='%23a0a3a5'/%3e%3c/svg%3e ">-->
          <!--                      <img :src="BackIcon400" id="back-to-sports" @click="resetFiltersOfSport " :width="32" :height="32" >-->

          <v-icon :src="BackIcon400" id="back-to-sports" @click="resetFiltersOfSport " :width="32"
                  :height="32">krypt-arrow-left
          </v-icon>
          {{selectedCategory.name}}

        </div>
        <div class="main-section-header-mobile" v-if="selectedSport ==='none'">

          {{ $t('sports.popular')}}
        </div>
        <v-btn :ripple="false" outlined id="filters-button" @click="showFiltersModalMobile"
               v-if="selectedSport !=='none' && selectedCompetition === 'none' && selectedCategory === 'none'">
          {{ $t('sidebar.competitions') | removeDiacriticsFromUppercase}}
        </v-btn>
      </v-row>
      <TimeFrameComponent v-if="selectedEvent === 'none'"></TimeFrameComponent>
      <!--      <router-view></router-view>-->
      <EventsList v-show="initialStateReady && selectedEvent ==='none'"></EventsList>
      <EventView v-show="initialStateReady && selectedEvent !=='none'"></EventView>
      <EmptyEventsList v-if="!initialStateReady "></EmptyEventsList>
      <!--        <EventView v-if="initialStateReady && selectedEvent !=='none'"></EventView>-->
    </div>

  </div>
</template>

<script>
import SoccerIcon from '../assets/Sports/Soccer.svg';
import TennisIcon from '../assets/Sports/Tennis.svg';
import TableTennis from '../assets/Sports/Ping-Pong.svg';
import CricketIcon from '../assets/Sports/Cricket.svg';
import BasteBallIcon from '../assets/Sports/Basketball.svg';
import SpecialBets from '../assets/Sports/Special Bets.svg';
import TimeFrameComponent from './TimeFrameComponent.vue';
import BackIcon from '../assets/utility/Arrow Left.svg';
import BackIcon400 from '../assets/utility/Arrow_Left_400.svg';

import EventsList from '@/components/views/EventsList';
import EventView from '@/components/views/Event';
import EmptyEventsList from '@/components/other/emptyEventsList';
import AlertBart from './other/kryptAlert.vue'

// import EmptyPageImg from '@/assets/utility/EmptyPage.svg';
// import(
//   /* webpackPrefetch: true */
//   /* webpackIgnore: true */
//   '../assets/utility/EmptyPage.svg')
export default {
  name: 'MainView',
  components: {
    TimeFrameComponent,
    EventsList,
    EventView,
    EmptyEventsList,
    AlertBart,

  },
  data: function () {
    return {
      sportsToIconsMapping: {
        0: SpecialBets,
        soccer: SoccerIcon,
        tennis: TennisIcon,
        basketball: BasteBallIcon,
        cricket: CricketIcon,
        tabletennis: TableTennis,
      },
      BackIcon: BackIcon,
      BackIcon400: BackIcon400,
    };
  },
  watch:{
    selectedEvent:function () {
      this.scrollToTop();
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    unSelectSport: function () {
      this.$store.dispatch('selectSportAndResetEvent', 'none');
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    selectCategory: function (category) {


      if(this.selectedSport ==='none'){
        this.$store.dispatch('selectSportAndResetEvent', this.sportsList.find((sportEntry) => {
          return sportEntry.id == category.data.sportId;
        }));
      }
      this.$store.commit('setSelectedEvent', 'none');
      this.$store.commit('setSelectedCategory', category.data);
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData',);

    },
    selectTournament: function (tournament) {

      if(this.selectedSport ==='none'){
        this.$store.dispatch('selectSportAndResetEvent', this.sportsList.find((sportEntry) => {
          return sportEntry.id == tournament.sportId;
        }));
      }
      this.$store.commit('setSelectedEvent', 'none');
      this.$store.commit('setSelectedTournament', tournament);

      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    resetFiltersOfSport: function (sport) {
      this.$store.dispatch('resetAllFiltersForSportAndEvent'  ,
        this.sportsList.find((sportEntry) => {
        return sportEntry.id === sport;
      })
    );
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    selectPopularAsSport: function () {
      this.$store.dispatch('selectSportAndResetEvent', 'none');
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    setSelectedSport: function (sport) {
      this.$store.dispatch('selectSportAndResetEvent', sport);
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    unSelectedCompetition: function (tournament) {
      this.$store.commit('setSelectedTournament', tournament);
    },
    showFiltersModalMobile: function () {
      this.$store.commit('setIsChoosingLeaguesMobile', true);
      this.$store.commit('resetMobileFiltersState');
      this.$store.commit('setTimeFilter', 'all');

    }
  },
  computed: {
    alertCase:function(){
      if(this.appIsOnline === false){
        return 'appOffline'
      }  else if(this.backendConnectionEstablished === false){
        return 'noWsConnection'
      } else if(!this.feedIsOnline){
        return 'feedOffline'
      }else{
        return 'online'
      }
    },
    feedIsOnline:function(){
      return this.$store.state.feedIsOnline;
    },
    appIsOnline:function(){
      return this.$store.state.appIsOnline;
    },
    backendConnectionEstablished:function(){
      return this.$store.state.backendConnectionEstablished;
    },
    selectedCompetitionInfo: function () {
      // let competitionInfo = 'none';
      if (this.selectedCompetition !== 'none') {
        return this.selectedCompetition;
      } else if (this.selectedEvent !== 'none') {
        return this.tournamentsList.find((tournamentEntry) => {
          return tournamentEntry.id === this.selectedEvent.tournamentId;
        });
      } else {
        return 'none';
      }
    },
    selectedCategoryInfo: function () {
      // let categoryInfo = 'none';

      if (this.selectedCategory !== 'none') {
        return {
          name: this.selectedCategory.name,
          id: this.selectedCategory.id,
          data:this.selectedCategory
        };

      } else if (this.selectedCompetition !== 'none') {
        return {
          name: this.selectedCompetition.category,
          id: this.selectedCompetition.categoryId,
          data: this.sportsList.find((sport)=>{return sport.id == this.selectedCompetition.sportId}).
          categories.find((category)=>{return category.id == this.selectedCompetition.categoryId})
        };
      } else if (this.selectedEvent !== 'none') {
        let tournamentFound =  this.tournamentsList.find((tournamentEntry) => {
          return tournamentEntry.id == this.selectedEvent.tournamentId;
        })
        return {
          name: tournamentFound.category,
          id: tournamentFound.categoryId,
          data: this.sportsList.find((sport)=>{return sport.id == tournamentFound.sportId}).
          categories.find((category)=>{return category.id == tournamentFound.categoryId})
        };
      } else {
        return 'none';
      }
    },
    selectedSportInfo: function () {
      let sportInfo = 'none';

      if (this.selectedSportData !== 'none') {
        return {
          name: this.selectedSportData.sportIdentifier,
          id: this.selectedSportData.id
        };
      } else if (this.selectedCategory !== 'none') {
        return {
          name: this.sportsList.find((sportEntry) => {
            return sportEntry.id == this.selectedCategory.sportId;
          }).sportIdentifier,
          id: this.sportsList.find((sportEntry) => {
            return sportEntry.id == this.selectedCategory.sportId;
          }).id
        };
      } else if (this.selectedCompetition !== 'none') {
        return {
          name: this.selectedCompetition.sportIdentifier,
          id: this.selectedCompetition.sportId
        };
      } else if (this.selectedEvent !== 'none') {
        return {
          name: this.tournamentsList.find((tournamentEntry) => {
            return tournamentEntry.id == this.selectedEvent.tournamentId;
          }).sportIdentifier,
          id: this.tournamentsList.find((tournamentEntry) => {
            return tournamentEntry.id == this.selectedEvent.tournamentId;
          }).sportId
        };
      } else {
        return 'none';
      }

    },
    tournamentsList: function () {
      let competitionsArray = [];
      this.$store.state.navigations.sports.forEach((sport) => competitionsArray = competitionsArray.concat(sport.tournaments));
      return competitionsArray;
    },

    selectedEvent: function (event) {
      return this.$store.state.navigations.selectedEvent;
    },
    initialStateReady: function () {
      return this.$store.state.initialStateReady;
    },
    nonDesktopMode: function () {
      {
        return this.$store.state.deviceMode !== 'desktop';
      }
    },
    laptopMode:function(){
      return (this.$store.state.deviceMode !== 'desktop' || this.$store.state.deviceMode !== 'laptop');

    },
    sportsList: function () {
      return this.$store.state.navigations.sports;
    },
    selectedSport: function () {
      return this.$store.state.navigations.selectedSport;
    },
    selectedSportData: function () {
      return this.$store.state.navigations.selectedSportData;
    },
    selectedCategory: function () {
      return this.$store.state.navigations.selectedCategory;
    },
    selectedCompetition: function () {
      return this.$store.state.navigations.selectedTournament;
    },
    selectedCompetitionsFromDifferentCategories: function () {
      if (this.selectedSport !== 'none') {
        if (this.selectedCompetitions.length > 1) {
          let initialCategory = this.selectedCompetitions[0].categoryId;
          let moreThanOneCategory = false;
          this.selectedCompetitions.forEach(
            (tournament => (tournament.categoryId != initialCategory && tournament.isSelected ? moreThanOneCategory = true : ''))
          );
          return moreThanOneCategory;
        } else {
          return false;
        }
      } else {
        return [];
      }

    }
  }
};
</script>

<style scoped>
  @media screen and (max-width: 1500px) and (min-width: 1280px) {
    .main-view-container-mobile {
      width: calc(100% - 360px);
    }

  }

  @media screen and (max-width: 1500px) and (min-width: 884px) {
    .main-view-container-mobile {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }

  #event-list-view {
    margin-top: 0px !important;
  }

  >>> .v-expansion-panel {
    margin-top: 8px !important;
  }

  >>> .v-expansion-panel:not(:first-child)::after {
    border-top: none;
  }

  .main-view-container {
    padding-left: 272px !important; /* 256 + 16 */
    /* padding-top: 8px;  - moved this to the breadcrumb and the time filter */
    padding-right: 376px !important; /* 360 + 16 */
    padding-bottom: 80px;
  }

  .v-breadcrumbs li:nth-child(even) {
    padding: 0px;
  }

  .v-breadcrumbs.theme--light > li {
    color: #000000;
    opacity: 0.5;
    font-size: 12px;
    line-height: 16px;
  }

  .v-breadcrumbs {
    padding-top: 8px;
    padding-bottom: 4px;
  }

  .v-breadcrumbs li .v-icon {
    color: #000000;
    font-size: 16px;
    line-height: 1;
  }

  .v-application ul.v-breadcrumbs {
    padding-left: 0px;
    padding-right: 8px;
  }

  .main-section-header, .main-section-header-mobile {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    display: flex;
    align-items: center;

    color: #0c1016 !important; /* Designer mentioned that all "black" colours should change to 900 */
  }

  >>> .main-section-header.v-subheader {
    padding-left: 0px !important;
    padding-right: 8px !important;
    height: auto !important;
  }

  #back-to-sports {
    cursor: pointer;
    margin-right: 24px;
  }

  >>> #back-to-sports .v-responsive__sizer {
    transition: none;
  }

  .breadcrumb-item:not(:last-child) {
    cursor: pointer;

  }

  .main-section-header-mobile {
    /* not required after left padding was added to the container element  margin-left: 8px; */
    margin-right: 8px;
    overflow: hidden;
  }

  .main-section-header-icon {
    margin-right: 8px;
    /*margin-bottom: 8px;*/
  }

  .main-view-container-mobile {
    /*padding-top:89px;*/
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 80px;
  }

  /* not required after right padding was added to the container element
  #filters-button{
    margin-right: 8px;
  } */
  #filters-button {
    letter-spacing: unset;
    font-weight: bold;
    font-size: 12px;
    padding: 8px;
    height: min-content;
    text-indent: 0;
    margin-left: 8px;
    color: var(--grey-900);
    background-color: var(--grey-300);
  }

  #filters-button:hover {
    background-color: var(--grey-300-state);
  }

  >>> #filters-button.v-btn--outlined {
    border-width: 0px;
  }

  >>> #filters-button > .v-btn__content {
    line-height: 16px;
  }

  >>> #filters-button.theme--light.v-btn:focus::before,
  >>> #filters-button.theme--light.v-btn:hover::before {
    opacity: 0;
  }

  .main-section-header-mobile-row {
    margin: 0px;
    justify-content: space-between;
    flex-wrap: nowrap;
  }

  #competitions-chips-row {
    margin: 0px;

  }

  >>> .mobile-column {
    padding: 0px;
  }

  .custom-toolbar {

    overflow-x: scroll;
    white-space: nowrap;
    padding: 4px;
    width: 100%;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    text-align: center;
    flex-wrap: nowrap;
  }

  .custom-toolbar::-webkit-scrollbar {
    display: none;
  }

  .custom-toolbar-cell {
    /* Auto Layout */

    cursor: pointer;
    display: block;
    flex-direction: column;
    /*padding: 2px 8px;*/
    margin-left: 16px;
    margin-right: 8px;
    padding-top: 0px;
    /*width: 68px!important;*/
    text-overflow: ellipsis;
    overflow: visible;
    /* 200 */
    white-space: nowrap;

    background: transparent;
    border-radius: 4px;
  }

  .desktop-header-row {
  }

  .time-filter-desktop {
    padding-left: 8px;
  }

  #back-to-sports, .v-list-item {
    cursor: pointer;
  }

  #back-to-sports {
    font-size: 32px;
    color: #A0A3A5;
  }

  #back-to-sports:hover {
    color: #5c5f61;
  }

  #back-to-sports.theme--light.v-icon:focus::after {
    opacity: 0;
  }

</style>
